// Dependency-free fetch helpers for the code that ships in the shared bundle and on the
// paid-search landing page (PromoBanner, LandingLeadForm). The rest of the app keeps using the
// axios instance in lib/api.js; pulling axios (~14 KB gzip) into the critical path just to make
// two requests was measurable on the landing page's LCP.
//
// Errors are shaped like axios errors (`err.response.status`, `err.response.data`) so call
// sites can read `err?.response?.data?.detail` exactly as they do with the axios client.
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

class ApiError extends Error {
  constructor(status, data) {
    super(`Request failed with status ${status}`);
    this.name = 'ApiError';
    this.response = { status, data };
  }
}

const parse = async (res) => {
  const text = await res.text();
  try { return text ? JSON.parse(text) : null; } catch { return text; }
};

const request = async (path, init) => {
  const res = await fetch(`${API_BASE}${path}`, { credentials: 'same-origin', ...init });
  const data = await parse(res);
  if (!res.ok) throw new ApiError(res.status, data);
  return { data, status: res.status };
};

/** GET JSON. Resolves `{ data, status }`. */
export const getJson = (path) => request(path, { method: 'GET', headers: { Accept: 'application/json' } });

/** POST a FormData body (multipart) — the shape /api/contact expects. Resolves `{ data, status }`. */
export const postForm = (path, formData) => request(path, { method: 'POST', body: formData });
